module.exports = __webpack_public_path__ + "img/product_27.c48b2da.webp";